import React from "react";
import { toast } from "sonner";
import { Linkedin, Link2, Share2 } from "lucide-react";

const XIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

export const ShareButtons = ({ title }) => {
  const url = typeof window !== "undefined" ? window.location.href : "";
  const enc = encodeURIComponent(url);
  const encT = encodeURIComponent(title || "");

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied");
    } catch {
      toast.error("Could not copy link");
    }
  };

  const base = "w-11 h-11 flex items-center justify-center border border-[#16281C]/20 text-[#16281C] hover:border-[#2C5F3A] hover:text-[#2C5F3A] transition-colors";

  return (
    <div data-testid="share-buttons" className="flex items-center gap-3">
      <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#8B978C] mr-1 inline-flex items-center gap-2"><Share2 size={13} /> Share</span>
      <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${enc}`} target="_blank" rel="noopener noreferrer" data-testid="share-linkedin" className={base} aria-label="Share on LinkedIn"><Linkedin size={17} /></a>
      <a href={`https://twitter.com/intent/tweet?url=${enc}&text=${encT}`} target="_blank" rel="noopener noreferrer" data-testid="share-x" className={base} aria-label="Share on X"><XIcon size={15} /></a>
      <button onClick={copy} data-testid="share-copy" className={base} aria-label="Copy link"><Link2 size={17} /></button>
    </div>
  );
};
